module.exports = __webpack_public_path__ + "img/brushes-2_jp.2012f24.jpg";